import React from 'react';
import { extend } from 'underscore';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';

export const WithApplyAndCloseButton = ({
  onApply,
  onDismiss,
  applyText,
  closeText,
  className,
}) => {
  const renderApply = data => (
    <button
      type="button"
      onClick={() => onApply(data)}
      onKeyDown={event =>
        submitEvent(onApply)(event, extend({ isKeyboardEvent: true }, data))}
      className="btn btn-primary"
    >
      {applyText}
    </button>
  );
  const renderDismiss = data => (
    <button
      type="button"
      onClick={() => onDismiss(data)}
      onKeyDown={event =>
        submitEvent(onDismiss)(event, extend({ isKeyboardEvent: true }, data))}
      className="btn btn-default"
    >
      {closeText}
    </button>
  );

  return Base => props => (
    <div className={className}>
      <Base renderApply={renderApply} renderDismiss={renderDismiss} {...props} />
    </div>
  );
};
